<template>
  <div class="header">
    <div class="width1000">
      <div class="flWrap clearFix">
        <div class="fl_float">
          <a href="/h5/index.html">
            <img class="logo"
                 src="../../assets/images/logo.png"
                 alt="慈善中国" />
          </a>
        </div>
        <div class="fr_float"
             v-show="login!=false">
          <div class="search">
            <el-input v-model="input"
                      placeholder="请输入搜索内容"></el-input>
            <div class="search-btn">搜索</div>
          </div>
          <!-- <div class="
                         reg_login
                         ">
            <el-button type="info
                         "
                       size="mini
                         ">登录</el-button>
            <el-button type="info
                         "
                       size="mini
                         ">注册</el-button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      input: ''
    }
  },
  props: ['login'],
  mounted () {
    // console.log(this.login);
  }
}
</script>
<style lang="less">
.header {
  height: 65px;
  line-height: 65px;
  margin-top: 10px;
  .logo {
    height: 60px;
    position: relative;
    top: 2px;
  }
}
.header .el-button--info {
  background-color: #f5f5f5;
  color: #666;
  border: none;
}
.fl_float {
  float: left;
}
.fr_float {
  float: right;
  height: 40px;
}
.search {
  float: left;
  width: 360px;
  position: relative;
  margin-right: 40px;
}
.search .el-input {
  width: 320px;
  border: none;
}
.search .el-input__inner {
  border: none;
  border-radius: 0;
  height: 36px;
  border-radius: 20px 0 0 20px;
  padding-right: 62px;
  background-color: #f5f5f5;
}

.search .search-btn {
  width: 80px;
  position: absolute;
  top: 14px;
  text-align: center;
  height: 38px;
  background: #e60012;
  line-height: 38px;
  color: #fff;
  font-size: 13px;
  right: 20px;
  border-radius: 40px;
}
.reg_login {
  float: right;
}
</style>


